import { memo, useState, useEffect } from 'react';
import CheckboxCustom from '../checkbox';
import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import i18n from 'i18';

const CheckboxGroup = ({ options, selectedValues = [], onChange }) => {
    const theme = useTheme();
    const [selectedOptions, setSelectedOptions] = useState(selectedValues);

    // Update state when new selectedValues are received
    useEffect(() => {
        if (selectedValues && selectedValues.length >= 0) {
            setSelectedOptions(selectedValues);
        }
    }, [selectedValues]);

    const handleCheckboxChange = (option) => {
        const updatedOptions = selectedOptions.includes(option)
            ? selectedOptions.filter((item) => item !== option)
            : [...selectedOptions, option];
        setSelectedOptions(updatedOptions);
        onChange(updatedOptions); // Callback
    };
    return (
        <Box
            sx={{
                display: 'flex',
                gap: theme.spacing(1),
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                marginY: theme.spacing(1),
            }}
        >
            {options.map((option, index) => {
                const checked = selectedOptions.includes(option);
                return (
                    <Box
                        key={index}
                        onClick={() => handleCheckboxChange(option)}
                        sx={{
                            "cursor": 'pointer',
                            "display": 'flex',
                            "gap": theme.spacing(1),
                            "padding": '10px 36px 10px 16px',
                            "alignItems": 'center',
                            "borderRadius": '8px',
                            //checked style:
                            "color": checked
                                ? theme.palette.primary.main
                                : theme.palette.text.default,
                            "backgroundColor": checked
                                ? theme.palette.primary.shadow
                                : theme.palette.background.default,
                            '&:hover': {
                                backgroundColor: checked
                                    ? theme.palette.primary.shadow
                                    : theme.palette.background.paper
                            }
                        }}
                    >
                        <CheckboxCustom
                            key={index}
                            checked={checked}
                            onChange={() => handleCheckboxChange(option)}
                        />
                        <Typography variant="body2">{i18n.t(`enums.${option}`)}</Typography>
                    </Box>
                );
            })}
        </Box>
    );
};

export default memo(CheckboxGroup);
